module.exports = __webpack_public_path__ + "static/media/headerLanding.9c08cd76.png";